export const faqs = `Bienvenido a Allas Repuestos.com\! ¿Podemos ayudarte a encontrar algo? Si tienes preguntas sobre cómo comprar en línea con nosotros, haz clic en un tema de ayuda a continuación y haremos todo lo posible por asistirte.

# **RECOMPENSAS ALLAS REPUESTOS (EXCLUSIVOS CLUB)®** **A continuación, respuestas a preguntas frecuentes sobre recompensas.**

## **¿Qué es el programa Recompensas Allas Repuestos (Exclusivos Club)?**

Recompensas Allas Repuestos (Exclusivos Club) es un programa gratuito que te ayuda a obtener más al comprar lo que necesitas. Obtendrás descuentos exclusivos al momento de realizar tus compras, además un Punto Exclusivos Club tras cada Lempira de compra, tendrás acceso a ofertas exclusivas solo para ti. Si necesitas ayuda para llevar un registro de tus compras e historial de servicio, nuestro programa te facilita esa tarea. Estos son solo algunos beneficios; para la lista completa visita **Allas Repuestos.com/Recompensas**

## **¿Cómo me uno al programa Allas Repuestos Rewards?**

Puedes unirte en cualquiera de nuestras tiendas Allas Repuestos participantes o descargando la Aplicacion desde tu celular en el App Store o Play Store.

## **¿Cómo gano un crédito o punto?**

Ganas un punto cuando por cada Lempira de compra (antes de impuestos) en una compra calificada en tienda, en línea o con Recogida el Mismo Día en tienda. Solo necesitas tu codigo QR Recompensas Allas Repuestos, desde tu tarjeta digital en el ALLAS APP al comprar en tienda. Al comprar en Allas Repuestos.com o en la app, inicia sesión o ingresa tu ID de Recompensas al pagar. Para más detalle sobre créditos y compras calificadas, consulta los Términos y Condiciones completos.

## **Después de obtener X créditos, ¿cómo recibo mi Recompensa?**

La cantidad de créditos o puntos recompensa se reflejarán en tu cuenta de Recompensas Allas Repuestos (exclusivos Club) al momento de cancelar tu factura en caja, y será visible en tu App. En algunos casos puede tardar más. Si tienes dudas, escribenos al WhatsApp (504)9508-9953.

## **¿Mis créditos o puntos Recompensas Allas Repuestos caducan?**

Las Recompensas de Allas Repuestos NO tienen fecha de caducidad. Para más detalle, consulta los Términos y Condiciones completos. 

## **Si olvido añadir mi ID de membresía en una transacción, ¿puedo aún ganar créditos y recompensas?**

1. Para poderle asignar puntos, créditos y/o Recompensas es necesario presentar el código QR de la Aplicación Allas Repuestos.  
2. o en su defecto hacer su compra en linea desde la aplicación y estar logueado con su cuenta de Recompensas Allas Repuestos (Exclusivos Club)

También puedes escribenos al WhatsApp (504)9508-9953 para asistencia.

## **¿Cómo me mantengo informado sobre el programa y accedo a ofertas exclusivas?**

* Conoce los beneficios y crea tu cuenta en Allas Repuestos.com/Recompensas. Si te uniste a la tienda, vincula tu cuenta con tu ID de Recompensas Exclusivas Club al comprar en línea.  
* Descarga la app Allas Repuestos para acceder fácilmente a tu ID de Recompensas y saldo.  
* Estate atento a nuestros correos y envíos impresos llenos de información y ofertas personalizadas.  
* Visita tu Allas Repuestos local o Allas Repuestos.com/circular para nuevas ofertas semanales.  
* Pregunta a un asesor de tienda sobre tu estado y saldo.

## **¿Qué necesito para canjear mis Recompensas en tienda?**

Busca tu ID de membresía, proporciona tu número de teléfono o escanea tu tarjeta digital.

## **¿Cómo canjeo mis Recompensas en línea?**

Por los momentos solo puedes canjear tus Premios Recompensas en una de nuestras tiendas y debe ser personal.

## **Al unirme, ¿por qué debo proporcionar mi correo y teléfono?**

Necesitamos que cada cuenta sea única y esté verificada por seguridad que los beneficios se le otorgan a los clientes correctamente.  Queremos mantenerte al día sobre tu membresía y enviarte ofertas exclusivas. Contar con tu correo y teléfono correctos es vital para ello y también nos ayuda a localizar tu cuenta si necesitas asistencia.

## **¿Cómo cambio mi correo o teléfono?**

* Inicia sesión en www.allasrepuestos.com/login y ve a Perfil bajo Mi Cuenta.  
* En la app, tocá “Más” y accede a “Mi Perfil”.  
* Visita tu tienda Allas Repuestos local y pide a un asociado que actualice tus datos.

## **¿Y si olvido mi contraseña o necesito cambiarla?**

Haz clic en “Olvidé mi contraseña?” al iniciar sesión, ingresa tu correo o usuario y recibirás un enlace para restablecerla en tu email.

## **Si mi información de membresía se pierde o es robada, ¿qué hago?**

Contacta de inmediato a un asesor en cualquiera de nuestras tiendas o escribenos al WhatsApp (504)9508-9953.

## **¿Puede alguien de mi familia usar mi membresía?**

No. Queremos que puedas seguir el historial de servicio y proteger tus créditos y recompensas. Sin embargo, cada miembro de la familia puede activar su propia membresía.

## **¿Puedo darme de baja del programa en cualquier momento?**

Sí. Envía tu solicitud por escrito a [servicioalcliente@allasrepuestos.com](mailto:servicioalcliente@allasrepuestos.com) desde el correo vinculado a tu membresía.

## **¿Puedo optar por no recibir comunicaciones del programa?**

Sí. Gestiona tus preferencias iniciando sesión en Allas Repuestos.com/signin o en ALLAS App y modificando en tu Perfil.

## **¿Quién puede unirse al programa?**

Si hay una tienda Allas Repuestos en tu área, puedes unirte.  Las cuentas comerciales de Allas Repuestos (Expertos Club) tampoco pueden participar.

## **¿Por qué no puedo acceder a la membresía creada en la tienda?**

Debes vincular tu ID de Recompensas Allas (Exclusivos Club) recibido en tienda con tu cuenta en Allas Repuestos.com. Ve a Allas App, ingresa tus datos y unifica tu cuenta, proporciona tu ID, correo electrónico y número de celular.

## **¿Venden, alquilan o licencian mi información personal, incluido mi historial de transacciones?**

No. En Allas Repuestos no vendemos, licenciamos ni alquilamos tu información personal a terceros. Tu información se usa únicamente para administrar los beneficios del programa Recompensas Allas Repuestos (Exclusivos Club).

# **LISTA DE COMPRAS EN TIENDA**

 ¿Tienes prisa? Acelera tu visita con listas de compras

Crea tu lista de compras en Allas Repuestos.com y envíala directamente a tu tienda local. Ahorrarás tiempo porque no tendrás que buscar las piezas en el mostrador: ¡ya sabemos lo que necesitas\!

¡Qué comodidad\! Además de imprimir tu lista de compras de Allas Repuestos.com en casa, ahora puedes enviarla directamente al mostrador de repuestos de tu tienda Allas Repuestos local.

Después de crear tu lista de compras, haz clic en el botón “Enviar por WhatsApp” y tu lista te estará esperando en tu Allas Repuestos preferido. Solo tienes que brindarle el numero de cotizacion, en el mostrador que hiciste una lista de compras en Allas Repuestos.com y él o ella se encargará del resto. Además, una vez que compres tus piezas, toda la información de tu garantía se registrará automáticamente en nuestra base de datos nacional de garantías.

## **¿Qué ocurre realmente cuando envío mi lista de compras a una tienda?**

Estás ingresando tu lista de deseos de piezas en la base de datos de Allas Repuestos, un asesor de contact center busca en nuestro inventario todos los repuestos de esa lista y genera una cotizacion y te la envía a ti y a tu tienda seleccionada para que pueda asegurarse de tener los repuestos para cuando tu asistas, ya están listos para comprar.

## **¿Por qué es más rápido enviar mi lista de compras a la tienda desde Allas[Repuestos.com](http://Repuestos.com)?**

Porque toda la información que necesita el empleado para localizar tus piezas ya está en el sistema. Además, si recoges una pieza con garantía, tu lista de compras la registra automáticamente por ti.

## **¿Cuánto tiempo permanecerá mi lista de compras en los ordenadores de la tienda?**

Tu lista estará en el sistema hasta el final del siguiente día.

## **¿Y después de eso?**

Tu lista de compras desaparece si no pasas por una tienda Allas Repuestos y completas la compra. Si aún quieres las piezas, simplemente confirma por WhatsApp que dia pasaras por que tienda de Allas Repuestos.

## **¿Puedo modificar mi lista de compras en la tienda?**

Sí. Tu lista de compras es una herramienta para ahorrar tiempo, no un compromiso de compra de artículos específicos. Siéntete libre de cambiar lo que necesites.

## **¿Mis piezas quedan reservadas?**

No. Tu lista de compras en Allas Repuestos.com no reserva las piezas. Recuerda, es una herramienta para ahorrar tiempo. Si deseas reservar piezas, llama a tu tienda local y pide que te las aparten. O utiliza Comprar en Línea y Recoger en Tienda para adquirirlas en línea y encontrarlas listas cuando llegues.

## **Si envío mi lista con éxito, ¿significa eso que mis piezas están en inventario?**

Para determinar si hay existencia de inventario de los repuestos de tu lista, preguntaselo a tu asesor por WhatsApp.

## **¿Por qué piden mi número de teléfono?**

Usamos tu número de teléfono único como número de identificación para la lista de compras y como referencia para todas las garantías de piezas de Allas Repuestos. También lo usaremos para comunicarnos contigo, para esclarecer dudas acerca de esta lista en particular.

## **¿Usarán mi número de teléfono para algún otro fin?**

No. Valoramos tu privacidad tanto como tú, y no usaremos tu número de teléfono para nada más que registrar la información de tu garantía y lista de compras en los sistemas de la tienda. Creemos que los números de teléfono protegidos cuidadosamente son la forma más segura y precisa de registrar información única de garantías. Para más detalles sobre nuestro compromiso con tu privacidad, lee nuestra Política de Privacidad.

## **¿Qué necesito llevar a la tienda para recoger las piezas de mi lista?**

El número de cotización que se le brinde por WhatsApp. Simplemente acércate al mostrador de repuestos, proporciona tu número de teléfono y tu información aparecerá en pantalla.

## **¿Puedo pagar en línea y recoger las piezas en la tienda?**

**¡**Por supuesto\! Ofrecemos la opción Comprar en Línea y Recoger en Tienda en todas las ubicaciones de Allas Repuestos. Para más información, consulta Comprar en Línea y Recoger en Tienda..

## **COMPRAS EN LÍNEA**

Comienza tu compra de repuestos en nuestra sección de Compras. Debes estar registrado y logueado con tu cuenta digital, seleccionar tu vehículo en mi carro, y seleccionar tu tienda preferida en mi tienda.  Una vez realizados estos pasos simplemente selecciona las piezas que deseas adquirir y AllasRepuestos.com te guiará en el proceso.  Envía tu lista o cotización por Whatsapp desde el carrito de compras y enseguida recibirás una cotización.  Luego esa cotización la ingresas en la sección Compra Ya, y te abrirá un carrito de compra que puedes modificar con los productos y cantidades que deseas agregar o eliminar.  Una vez tengas el carrito listo agregas tu método de pago y das siguiente, en forma de envío escoges la opción recoger en tienda sin cobro, asegurate que estes en la tienda que más te conviene, aca todavia podras hacer cambios en tu tienda seleccionado.  Una vez seleccionada le das finalizar y el sistema te generará un código QR que debes presentar en tu sucursal seleccionada.  Y tu pedido y factura estará listo sin inconvenientes para que pases por él.

**¿CUÁNDO PUEDO COMPRAR?**  
Siempre que necesites un repuesto de automóvil. Allasrepuestos.com está abierto las 24 horas del día, los 7 días de la semana. Tu pedido se procesará y enviará dentro de dos días hábiles después de realizarlo (de 3 a 5 días hábiles si adquiriste artículos de pedido especial).

¿PAGO IMPUESTO LOCAL EN MIS COMPRAS EN allasrepuestos.com?  
Sí. Como las tiendas Allas Repuestos operan en las principales ciudades del país, debemos cumplir cuidadosamente con los códigos fiscales estatales y locales al hacer compras en línea. 

¿QUÉ TARJETAS DE CRÉDITO ACEPTA allasrepuestos.com?  
Actualmente aceptamos Visa, MasterCard, American Express, Tarjetas de Regalo Allas Repuestos (con PIN). También aceptamos tarjetas de débito con los logotipos Visa y MasterCard.  
Allas Repuestos.com acepta pagos con transferencias electrónicas de los principales bancos del país. No aceptamos cheques personales, tarjetas de débito sin los logotipos Visa o MasterCard, ni tarjetas EBT.

¿CUÁNDO SE CARGA MI PEDIDO A LA TARJETA Y CUÁNDO SE ABONA SI LO DEVUELVO?  
Al procesar tu pedido, colocamos una “preautorización” por el monto de la compra. No cobramos tu tarjeta hasta que los artículos se hayan enviado. Si devuelves un artículo a Allas Repuestos.com o a cualquier tienda Allas Repuestos, procesaremos el reembolso el mismo día que tramitemos la devolución.

 ¿HAY UN LÍMITE MÁXIMO DE PEDIDO?  
No. Solo existe excepción en promociones especiales con límite por pedido.

¿CÓMO CONSULTAR EL ESTADO DE MI PEDIDO?  
Escribiendo al Centro de Atención al Cliente de Allas Repuestos al (504) 2283-4540. Ten a la mano tu número de pedido. También puedes enviar un correo a Servicio al Cliente incluyendo tu número de pedido.

Ingresando a Allas App en tu cuenta, en la sección de rastrear mis pedidos.

¿CUÁNTO HORARIO TIENE EL CENTRO DE ATENCIÓN?  
El Centro de Atención está abierto de 8 a. m. a 5 p. m. de lunes a viernes.

¿LAS COMPRAS EN LÍNEA TIENEN LA MISMA GARANTÍA QUE EN TIENDA?  
Sí. Las piezas compradas en Allas Repuestos.com tienen las mismas garantías que si las adquirieras en tienda. Consulta nuestras Garantías para más detalles.

¿allasrepuestos.com ES UN SITIO SEGURO?  
allasrepuestos.com utiliza tecnología estándar de la industria para transacciones seguras en línea, al menos tan seguro como proporcionar tu tarjeta de crédito por teléfono. Lee más sobre nuestra seguridad.

¿CUÁL ES LA POLÍTICA DE PRIVACIDAD DE Allas Repuestos.com?  
Allas Repuestos.com solo conserva la información necesaria para identificar y atender las necesidades e intereses de los clientes, y se esfuerza por usarla para ofrecer productos y servicios valiosos. No vende ni distribuye tu información a terceros no afiliados. Para más detalles, consulta nuestra Política de Privacidad.

¿PUEDO CANCELAR MI PEDIDO DESPUÉS DE REALIZARLO?  
Sí. Puedes cancelar tu pedido hasta antes de que se envíe. Los artículos de pedido especial no pueden cancelarse. Una vez enviado, puedes devolverlo en tiendas Allas Repuestos o enviarlo al centro de cumplimiento según la Política de Devoluciones en Línea. Para cancelar, escribe al Centro de Atención al Cliente al (504) 2284-4540 con tu número de pedido, y tendrás que anotar el número de gestión de cancelación, para futuros reclamos.

¿CÓMO DEVUELVO UN PRODUCTO COMPRADO EN LÍNEA?  
Las devoluciones son sencillas: lleva tu compra a cualquier tienda Allas Repuestos. Haz clic aquí para encontrar la más cercana. Si prefieres devolverlo por correo, empaca tus artículos junto con el Formulario de Devolución incluido en la factura de envío. Revisa nuestros Términos y Condiciones para la Política de Devoluciones completa.

¿CÓMO DEVUELVO UN PRODUCTO COMPRADO EN TIENDA?  
Lleva tu compra y la tarjeta con la que pagaste a la tienda. Si no tienes la tarjeta o usaste otro método, lleva el recibo y te reembolsarán.

¿Y SI NO ENCUENTRO MI RECIBO?  
Contacta al Soporte al Cliente de Allas Repuestos al (504) 2283-4540. Nuestros representantes harán seguimiento de la transacción y te ayudarán con la devolución.

¿PUEDO DEVOLVER UNA TARJETA DE REGALO Allas Repuestos?  
Todas las ventas de tarjetas de regalo son finales y no pueden devolverse, ni en línea ni en tienda.

¿TENGO MÁS PREGUNTAS?  
Visita nuestros Términos y Condiciones para la Política de Devoluciones, Política de Garantías y más.

¿PAGO ENVÍO POR LAS DEVOLUCIONES EN LÍNEA?  
No pagas el envío si la devolución se debe a nuestro error (pieza equivocada o dañada). Nosotros cubrimos ese envío. Escríbenos al Centro de Atención y coordinaremos tu envío de vuelta. Para más detalles, revisa la Política de Devoluciones en Línea.

Todas las compras en este sitio web se realizan a través de Allasrepuestos.com.

## **TARJETAS DE REGALO O CRÉDITO DE MERCANCÍA ALLAS REPUESTOS**

A continuación, respuestas a preguntas frecuentes sobre tarjetas de regalo.

**¿Qué es la Tarjeta de Regalo Allas Repuestos?**  
La tarjeta de regalo Allas Repuestos es una tarjeta de saldo decreciente que los consumidores pueden adquirir en cualquiera de las tiendas Allas Repuestos y puede utilizarse para la compra de mercancía en cualquier tienda Allas Repuestos. En algunos casos, la Tarjeta de Regalo Allas Repuestos puede utilizarse en formato electrónico como e-Gift Card. Las tarjetas de regalo, las tarjetas de mercancía y los créditos de tienda pueden aplicarse a pedidos de Recogida en Tienda ni a pedidos con Entrega el Mismo Día. La Tarjeta de Regalo Allas Repuestos nunca expira y no tiene cargos por inactividad. Las tarjetas de regalo no pueden canjearse por efectivo.

**¿Qué es el Crédito de Mercancía Allas Repuestos?**  
El Crédito de Mercancía Allas Repuestos es un crédito de mercancía emitido en forma de tarjeta de saldo decreciente y puede utilizarse para comprar mercancía en cualquiera de las tiendas Allas Repuestos. Los Créditos de Mercancía Allas Repuestos no pueden comprarse.

**¿Dónde puedo comprar Tarjetas de Regalo Allas Repuestos?**  
La Tarjeta de Regalo Allas Repuestos está disponible para su compra en cualquiera de las tiendas Allas Repuestos y también en Allasrepuestos.com.

**¿Qué formas de pago aceptan para la compra de Tarjetas de Regalo Allas Repuestos?**  
En línea aceptamos Visa, MasterCard, y American Express. Hay un límite de Lps 5,000 por tarjeta de regalo. Para compras en tienda se aceptan otros tipos de pago.

**¿Puedo comprar Tarjetas de Regalo Allas Repuestos y enviarlas a otra persona?**  
Podemos enviar tus Tarjetas de Regalo a cualquier dirección válida en Honduras. Puedes incluir un mensaje de regalo con tu compra de Tarjeta de Regalo.

**¿Cuál es el tiempo de envío?**  
El tiempo de envío dependerá del método de entrega que selecciones. haz clic aquí para más detalles sobre envíos.

**¿Cómo puedo consultar el saldo restante de mi Tarjeta de Regalo?**  
Para conocer el saldo disponible de una Tarjeta de Regalo, haz clic aquí o simplemente visita cualquiera de las tiendas Allas Repuestos y pide al cajero que lo consulte por ti. También podemos proporcionar saldos de Tarjetas de Regalo por teléfono o en línea, a través de nuestros servicios de correo electrónico y chat.

## **ENVÍO**

| Método de envío | Costo |
| :---- | :---- |
| Entrega el Mismo Día | Desde L. 120 |
| Entrega al Día Siguiente | L. 100 en pedidos inferiores a L. 1,000; GRATIS en pedidos superiores a L. 1,000 |
| Entrega Estándar | (C807, Cargo Expreso, Rápido Cargo) Lps 120 en pedidos inferiores a Lps 1,000.00; GRATIS en pedidos superiores a Lps 1,000.00 |
| Entrega Rápida | Varía según peso y destino |
| Envío por flete | Lps 150.00 |

*El costo de envío puede estar sujeto a impuestos.*

**¿Cómo se enviará mi compra?**  
Allas Repuestos.com envía vía Allas Delivery, Rapido Cargo, Cargo Expreso y C807 Delivery. (servicio puerta a puerta)

* **Entrega Estándar:** 3–5 días hábiles tras procesar tu pedido  
* **Entrega Rápida (Rush):** 2 días hábiles.  
* **Entrega Exprés:** Día siguiente.  
* **Entrega mismo día:** Disponible únicamente para las ciudades donde hay una tienda Allas Repuestos. 

También podemos enviar mediante ciertas empresas de buses, a ciertas ciudades.  En este caso tú serías responsable de recoger tu pedido en dicha terminal.

**Responsabilidad del cliente:** tú pagas todos los cargos, aranceles, tasas e impuestos en pedidos por flete.

Dependiendo del tamaño, peso, disponibilidad y otros factores, un pedido puede enviarse en múltiples envíos o desde diferentes ubicaciones. Los métodos de envío serán los que elijas al pagar. Los tiempos de entrega dependerá de la opción seleccionada. Parte del pedido con artículos especiales puede cobrarse al momento de realizarlo.

**¿Puedo enviar mi pedido a una dirección distinta de la registrada en Allas Repuestos.com?**  
 Sí. Durante la compra puedes ingresar una dirección de envío diferente.

**¿Pago envío por devoluciones a Allas Repuestos.com?**  
 No pagas envío si la devolución es por error nuestro (pieza equivocada o dañada). Escribe al Centro de Atención al Cliente y coordinaremos el envío de devolución. Para más detalles, consulta nuestra Política de Devoluciones en Línea.

## **ENVÍO EL MISMO DÍA**

Entrega el Mismo Día en Allas Repuestos.com es nuestro servicio más rápido.

**¿Cómo funciona?**  
Selecciona una tienda y busca las piezas que necesitas. Cada tienda tiene un radio de entrega de 7 millas. En los productos disponibles hoy verás “Entrega el Mismo Día”. En el pago, elige la opción “Entregar hoy” en los artículos elegibles. Haz tu pedido antes de las 4pm y Allas Repuestos coordinará con nuestros socios para entregarlo el mismo día.

Las promociones no aplican a pedidos de Entrega el Mismo Día, y estos pedidos **no pueden cancelarse**. Puedes devolverlo en cualquier tienda Allas Repuestos: lleva el producto en su empaque original y tu recibo.

**¿Cómo rastreo mi pedido?**  
Durante el pago, suscríbete a notificaciones por texto. Recibirás un correo de confirmación. Una vez la tienda prepare tu pedido, el socio de entrega lo recogerá y te lo entregará el mismo día. Rastrea tu pedido en tiempo real con el Allas App en Rastrea mis pedidos.

**¿Y la entrega?**  
Tu pedido se entregará en la dirección indicada y se tomará una foto como comprobante. El repartidor contará con tu teléfono para contactarte. Recibirás confirmación con enlace a la prueba de entrega. Entrega el Mismo Día **no incluye servicios en tienda** (pruebas de alternador, instalación de baterías, etc.).

Para cambios o actualizaciones de tu pedido, escribe al 2283-4540.

## **ENVÍO AL DÍA SIGUIENTE**

 **¿Qué es Allas Repuestos Next Day Delivery (“NDD”)?**  
Next Day Delivery es una opción de envío nocturno para entrega a domicilio en direcciones elegibles.  (Direcciones en la misma ciudad donde hay tienda de Allas Repuestos.

**¿Cómo selecciono NDD?**  
Elige “Enviar a domicilio” al agregar un artículo al carrito. Si la dirección es apta para NDD, verás “Next Day Delivery Disponible”. Luego selecciona NDD en la pantalla de pago antes de ordenar.  Si tu compra es Superior a Lps 1,000 tu envio será completamente gratis.  

**¿Cuándo debo ordenar para recibir al día siguiente?**  
El horario límite será 11:59 pm. Al agregar al carrito verás la hora de corte. La hora final de corte aparece en tu carrito o resumen de pedido. Si seleccionas NDD después de la hora de corte, se mostrará la nueva fecha estimada de entrega.

**¿Qué puedo enviar con NDD?**  
Todos los  artículos que sean elegibles por el inventario disponible en la ciudad, la limitante es la dirección de entrega del pedido, debe ser una cuidad donde exista una tienda Allas Repuestos . Al agregar al carrito verás si puede enviarse al siguiente día y la hora límite.

**¿Qué pasa si los productos NDD no están disponibles?**  
La disponibilidad y la hora de pedido pueden afectar la llegada. Si no hay stock en nuestro almacén, intentaremos enviarlo por Rapido Cargo Standard, pero no garantizamos la entrega al día siguiente por causas ajenas a nuestro control.

**¿Qué destinos incluye NDD?**  
NDD está disponible para códigos postales selectos determinados por la dirección de envío. La disponibilidad depende si existe una tienda Allas Repuestos en la dirección de entrega.

**¿Cómo devuelvo un artículo NDD?**  
Igual que cualquier otro pedido. Si no estás satisfecho, llévalo con el recibo a tu tienda Allas Repuestos local y te reembolsaremos con el mismo método de pago. Si no hay tienda cerca, escribenos al (504) 2283-4540 y te ayudaremos con la instrucción y etiqueta de envío. Se aplican las políticas normales de devolución de Allas Repuestos.
`;
